export default "assets/images/8e5d0335f6598b8d874ba23ea9fb295f.png";